module.exports = __webpack_public_path__ + "static/ibm-plex-sans-v7-latin-500-f6d5c5d5b849796d6a8f5a2953b60753.woff";